import { setApiStatus } from '../ApiStatusActions';

export const SET_NOTIFICATION = 'SET_NOTIFICATION';
const ADD_CONVERSATION_DETAILS = 'ADD_CONVERSATION_DETAILS';
export const SET_ORG_LEVEL_CONVERSATIONS = 'SET_ORG_LEVEL_CONVERSATIONS';
export const APPEND_ORG_LEVEL_CONVERSATIONS = 'APPEND_ORG_LEVEL_CONVERSATIONS';
export const SET_ORG_LEVEL_CONVERSATIONS_TOTAL_COUNT = 'SET_ORG_LEVEL_CONVERSATIONS_TOTAL_COUNT';
export const SET_ORG_LEVEL_PERSON_DETAILS = 'SET_ORG_LEVEL_PERSON_DETAILS';
export const APPEND_ORG_LEVEL_PERSON_DETAILS = 'APPEND_ORG_LEVEL_PERSON_DETAILS';
export const SET_REPORT_CONVERSATION_DETAILS = 'SET_REPORT_CONVERSATION_DETAILS';
export const SET_SUBSCRIPTION_STATS = 'SET_SUBSCRIPTION_STATS';

const SET_LATEST_MESSAGES = 'SET_LATEST_MESSAGES';

export function setNotification(type, messageData, message) {
  return {
    type: SET_NOTIFICATION,
    payload: {
      Type: type,
      MessageData: messageData,
      ...(message && { Message: message }),
    },
  };
}

function setConversationDetails(conversationDetails) {
  return {
    type: ADD_CONVERSATION_DETAILS,
    payload: conversationDetails,
  };
}

function setLatestMessages(conversationId, personId, messages, userId, Total) {
  return {
    type: SET_LATEST_MESSAGES,
    payload: {
      conversationId,
      personId,
      messages,
      userId,
      Total,
    },
  };
}

const setFetchConversationMailsApiStatus = status => {
  const apiName = 'SetConversationMailsApiStatus';
  return setApiStatus({ apiName, status });
};

const setFetchContextualMailsConversationApiStatus = status => {
  const apiName = 'setContextualMailsConversationApiStatus';
  return setApiStatus({ apiName, status });
};

const setFetchAllContextualMailsConversationApiStatus = status => {
  const apiName = 'setAllContextualMailsConversationApiStatus';
  return setApiStatus({ apiName, status });
};

const setFetchConversationMessagesApiStatus = status => {
  const apiName = 'SetConversationMessagesApiStatus';
  return setApiStatus({ apiName, status });
};

export const setReportConversationApiStatus = status => {
  const apiName = 'ReportConversationApiStatus';
  return setApiStatus({ apiName, status });
};

export const setGetReportConversationDetailsApiStatus = status => {
  const apiName = 'ReportConversationDetailsApiStatus';
  return setApiStatus({ apiName, status });
};

export const setReportConversationDetails = payload => {
  return {
    type: SET_REPORT_CONVERSATION_DETAILS,
    payload,
  };
};

export const setFetchOrgLevelConversations = status => {
  return {
    apiName: 'fetchOrgLevelConversations',
    status,
  };
};

export const appendOrgLevelConversations = payload => {
  return {
    type: APPEND_ORG_LEVEL_CONVERSATIONS,
    payload,
  };
};

export const appendOrgLevelPersonDetails = payload => {
  return {
    type: APPEND_ORG_LEVEL_PERSON_DETAILS,
    payload,
  };
};

export const setOrgLevelConversations = payload => {
  return {
    type: SET_ORG_LEVEL_CONVERSATIONS,
    payload,
  };
};

export const setOrgLevelConversationsCount = payload => {
  return {
    type: SET_ORG_LEVEL_CONVERSATIONS_TOTAL_COUNT,
    payload,
  };
};
export const setOrgLevelPersonDetails = payload => {
  return {
    type: SET_ORG_LEVEL_PERSON_DETAILS,
    payload,
  };
};

export {
  setConversationDetails,
  ADD_CONVERSATION_DETAILS,
  setFetchConversationMailsApiStatus,
  setFetchConversationMessagesApiStatus,
  setLatestMessages,
  setFetchContextualMailsConversationApiStatus,
  setFetchAllContextualMailsConversationApiStatus,
};
